import React, { createContext, useState, useContext, ReactNode } from 'react';
import PopupModel from './PopupModel';


interface PopupContextType {
  popup: PopupModel | null;
  isVisible: boolean;
  showPopup: (header: string, body: React.ReactNode, buttons: { label: string; onClick: () => void }[], width?:string) => void;
  hidePopup: () => void;
}

const PopupContext = createContext<PopupContextType | undefined>(undefined);

export const PopupProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [popup, setPopup] = useState<PopupModel | null>(null);
  const [isVisible, setIsVisible] = useState(false);

  const showPopup = (header: string, body: React.ReactNode, buttons: { label: string; onClick: () => void }[], width?:string) => {
    if (!width){
      setPopup({ header, body, buttons});
    }
    else{
      setPopup({ header, body, buttons, width });}
    setIsVisible(true);
  };

  const hidePopup = () => {
    setPopup(null);
    setIsVisible(false);
  };

  return (
    <PopupContext.Provider value={{ popup, isVisible, showPopup, hidePopup }}>
      {children}
    </PopupContext.Provider>
  );
};

export const usePopup = (): PopupContextType => {
  const context = useContext(PopupContext);
  if (!context) {
    throw new Error('usePopup must be used within a PopupProvider');
  }
  return context;
};

export {};